<template>
  <div class="container mt-2">
    <div class="row">
      <div class="col-8">
        <h1>Vorabprüfung Mietangebot</h1>
        <h5>Vielen Dank für die Nutzung unseres Online-Services.</h5>
      </div>
      <div class="col-4">
        <img class="img-fluid" src="../assets/jobcenter_logo.jpg"/>
      </div>
    </div>

    <div id="cq_rent_calculator_result_userinput">
      <div class="row">
        <p class="fw-bold text-decoration-underline">Sie haben folgende Daten eingegeben:</p>
        <div class="col-8">
          <label>Personenzahl:</label>
        </div>
        <div class="col-4">
          {{ this.$store.state.persons }}
        </div>
      </div>
      <div v-if="this.$store.state.space" class="row">
        <div class="col-8">
          <label>Wohnfläche in m²:</label>
        </div>
        <div class="col-4">
          {{ this.$store.state.space }}
        </div>
      </div>


      <div class="row">
        <div class="col-8">
          <label>Kaltmiete ohne Nebenkosten (inkl. ggf. Kosten f. Möblierung) in €:</label>
        </div>
        <div class="col-4">
          {{ this.$store.state.coldRentWithoutNk }}
        </div>
      </div>


      <div class="row">
        <div class="col-8">
          <label>Nebenkosten ohne Heizkosten in €:</label>
        </div>
        <div class="col-4">
          {{ this.$store.state.coldRentWithoutHeatingCost }}
        </div>
      </div>


      <div v-if="this.$store.state.garageCost" class="row">
        <div class="col-8">
          <label>Kosten für Stellplatz/ Garage in €:</label>
          <div id="garageCostHint" class="form-text">(falls Anmietung zwingend erforderlich, bitte vom Vermieter
            bestätigen lassen.)
          </div>
        </div>
        <div class="col-4">
          {{ this.$store.state.garageCost }}
        </div>
      </div>

      <div class="row">
        <div class="col-8">
          <label>Liegt für das Gebäude ein Energie<span class="fw-bold">bedarfs</span>ausweis mit einem Wert von maximal 100 Kilowattstunden je m²
            pro Jahr vor?</label>
        </div>
        <div class="col-4">

          <span v-if="this.$store.state.energy" class="result-value">
            Ja
          </span>
          <span v-else class="result-value">
            Nein
          </span>
        </div>
      </div>
    </div>


<div id="cq_rent_calculator_result">
    <p class="fw-bold text-decoration-underline">Ergebnis der Prüfung:</p>
      <div class="row">
        <div class="col-8">
          <label>Kaltmiete in €:</label>
        </div>
        <div class="col-4">
          <span class="fw-bold">{{ sumOwnData(this.$store.state.coldRentWithoutNk, this.$store.state.coldRentWithoutHeatingCost, this.$store.state.garageCost) }}</span>
        </div>
      </div>

    <div class="row">
      <div class="col-8">
        <label>Angemessene Kaltmiete inklusive Nebenkosten in €:</label>
      </div>
      <div class="col-4">
        <span class="fw-bold">{{ showIndividualData(this.$store.state.energy) }}</span>
      </div>
    </div>

  <div class="mt-3">
    <div v-if="parseFloat(sumOwnData(this.$store.state.coldRentWithoutNk, this.$store.state.coldRentWithoutHeatingCost, this.$store.state.garageCost)) <= parseFloat(showIndividualData(this.$store.state.energy))">
      <input type="text" class="form-control is-valid text-center fw-bold" readonly value="Miete ist angemessen">
    </div>
    <div v-else>
      <input type="text" class="form-control is-invalid text-center fw-bold" readonly value="Miete ist nicht angemessen">
    </div>
    <div>
    </div>
  </div>
</div>
    <div class="row mt-4">
      <span id="cq_rent_calculator_result-hint" class="text-decoration-underline text-center">Bitte beachten Sie:</span>
      <p>
        Diese Vorabprüfung dient für Sie als Anhaltspunkt. Das Ergebnis<br>
        - ist nicht verbindlich,<br>
        - stellt keine Genehmigung bzw. Zusage zum Umzug sowie<br>
        - keinen Rechtsanspruch auf etwaige Umzugskosten und/oder Mietkautionen dar.<br>
        <br>
        Um eine rechtsverbindliche Zusicherung zu erhalten reichen Sie bitte das Mietangebot (ggfs. zusammen mit dem
        Energiebedarfsausweis) beim Jobcenter Münster ein. Jeder Antrag wird individuell geprüft und kann anders
        beschieden werden.
      </p>
      <h6>Die Prüfung ist nur für den Wohnraum in Münster gültig.</h6>
    </div>
    <button class="btn btn-primary" @click="$router.push('calculate')">Neue Berechnung</button>
  </div>
  <div class="container mt-4 mb-2">
    <div class="row">
      <div class="col-4 text-center">
        <a href="https://www.stadt-muenster.de/jobcenter/index">Startseite</a>
      </div>
      <div class="col-4 text-center">
        <a href="https://www.stadt-muenster.de/jobcenter/impressum">Impressum</a>
      </div>
      <div class="col-4 text-center">
        <a href="https://www.stadt-muenster.de/jobcenter/datenschutz">Datenschutz</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Calculation-Result',
  methods: {
    sumOwnData(coldRentWithoutNk, coldRentWithoutHeatingCost, garageCost) {
      if (!garageCost) {
        garageCost = '0,00';
      }
      let total = 0;
      total = parseFloat(coldRentWithoutNk.replace(',', '.')) + parseFloat(coldRentWithoutHeatingCost.replace(',', '.')) + parseFloat(garageCost.replace(',', '.'));
      return total.toString().replace('.', ',');
    },
    showIndividualData(energy) {
      if (energy) {
        return parseFloat(this.$store.state.data.with_energy[this.$store.state.persons - 1].cost).toFixed(2).toString().replace(".", ",");
      } else {
        return parseFloat(this.$store.state.data.without_energy[this.$store.state.persons - 1].cost).toFixed(2).toString().replace(".", ",");
      }
    }
  }
}
</script>

<style>

#cq_rent_calculator_result_userinput {
  border: .2rem solid #005b78;
  border-radius: 1rem;
  padding-left: 1rem;
  padding-bottom: 1rem;
  padding-top: 1rem;
}
#cq_rent_calculator_result {
  border: .2rem solid #005b78;
  border-radius: 1rem;
  padding: 1rem;
  margin-top: 1rem;
}
input.form-control.is-valid.text-center.fw-bold {
  border: 0.4rem solid #198754;
}
input.form-control.is-invalid.text-center.fw-bold {
  border: 0.4rem solid #dc3545;
}
span#cq_rent_calculator_result-hint {
  color: #dc3545;
  font-weight: bold;
  font-size: larger;
}
</style>